import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { LookupListResponse } from '@shared/services/responses/repo-dfse/lookup-list.response';
import { StatusFiscalNFSeEntradaLookupResponse } from '@shared/services/responses/repo-dfse/status-fiscal-nfse-entrada-lookup.response';

/**
 * Lookups fixos do Serviço Tomado, hospedados em ATS.Hub.API.RepoDFSe (Natureza da Base de
 * Cálculo do Crédito e Origem do Crédito são catálogos do SPED Contribuições — provisório aqui,
 * candidatos a migrar para a MotorFiscal no futuro).
 */
@Injectable({ providedIn: 'root' })
export class ServicoTomadoLookupService extends CommonService {
  private readonly apiUrl: string = environment.urlApiRepoDFSe + 'Lookup';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getNaturezaBaseCalculoCredito(): Observable<LookupListResponse> {
    return this.httpClient
      .get<LookupListResponse>(`${this.apiUrl}/natureza-base-calculo-credito-sped`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getOrigemCredito(): Observable<LookupListResponse> {
    return this.httpClient
      .get<LookupListResponse>(`${this.apiUrl}/origem-credito-sped`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getStatusFiscal(): Observable<StatusFiscalNFSeEntradaLookupResponse> {
    return this.httpClient
      .get<StatusFiscalNFSeEntradaLookupResponse>(`${this.apiUrl}/status-fiscal-nfse-entrada`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
